import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Stack,
  Box,
  Button,
} from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import { createWorker } from "tesseract.js";
import { useSnackbar } from "notistack";

const ImageWithRectangles = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const canvasRef = useRef(null);
  const [words, setWords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isReady, setIsReady] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Check if current is null to ensure the component is mounted
        await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for the component to mount
        if (canvasRef.current) {
          const canvas = canvasRef.current;
          const ctx = canvas.getContext("2d");
          const img = new Image();
          img.src = props.imageUrl;

          img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
          };
          await runImage(props.imageUrl);
        } else {
          throw new Error("canvasRef is not mounted");
        }
      } catch (error) {
        console.error("Error getting data:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  const onCanvasClick = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    console.log(e);
    console.log(words);
    const reslts = words.find(
      (h) => h.x0 <= x && h.x1 >= x && h.y0 <= y && h.y1 >= y,
    );
    if (reslts !== undefined) {
      console.log(reslts.word);
      navigator.clipboard.writeText(reslts.word);
      enqueueSnackbar(`${reslts.word} copied to clipboard`, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
    }
  };

  const runImage = async (iUrl) => {
    (async () => {
      const worker = await createWorker("eng", 1);
      const words = await worker.recognize(
        iUrl,
        { rotateAuto: true },
        { blocks: true },
      );
      console.log(words);
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      var wrds = [];
      // var idx = 0;
      for (const sss of words.data.blocks[0].paragraphs[0].lines) {
        sss.words.forEach((word) => {
          context.beginPath();
          context.rect(
            word.bbox.x0,
            word.bbox.y0,
            word.bbox.x1 - word.bbox.x0,
            word.bbox.y1 - word.bbox.y0,
          );
          // context.fillStyle = "yellow";
          // context.fill();
          context.lineWidth = 2;
          context.strokeStyle = "yellow";
          context.stroke();
          console.log(
            `${word.text}  -   Bounding Box: ${word.bbox.x0}, ${word.bbox.y0}, ${word.bbox.x1}, ${word.bbox.y1}`,
          );
          wrds.push({
            word: word.text,
            x0: word.bbox.x0,
            y0: word.bbox.y0,
            x1: word.bbox.x1,
            y1: word.bbox.y1,
          });

          // idx += 1;
        });
        setWords(wrds);
      }
      await worker.terminate();
    })();
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      open={props.isScanOpen}
      onClose={props.onScanClose}
      scroll={"paper"}
    >
      <DialogTitle style={{ paddingTop: 0, paddingBottom: 0 }}>
        {"Image OCR"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {
            "Click on the words to copy them to clipboard. You can also zoom in on the image to see the words more clearly."
          }
        </DialogContentText>

        <Box
          noValidate
          // component="form"
          // sx={{
          //   // display: "flex",
          //   flexDirection: "column",
          //   m: "auto",
          //   width: "100%",
          //   flexGrow: 1,
          // }}
        >
          <canvas
            // style={{ maxWidth: "50%", maxHeight: "50%" }}
            ref={canvasRef}
            onClick={onCanvasClick}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2}>
          <Button
            onClick={props.onScanClose}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ImageWithRectangles;
